import { AddCardFail } from "@widgets/payments/ui/add-card-fail/add-card-fail"

export const AddCardFailPage = () => {
	return <AddCardFail />
}
